var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('block-digital-scene',{class:{ '-with-image': _vm.data.image },attrs:{"title":_vm.data.title,"body":_vm.data.body,"image":_vm.data.image,"button-text":_vm.data.linkText,"button-url":_vm.data.linkUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }